<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { STATS } from '@/store/types';
import statsApi from '../../apis/stats.api';

export default {
  props: {
    type: {
      type: String,
      default: 'monthly',
    },
    from: String,
    to: String,
  },

  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = statsApi.useAvgCommuteModeDistanceQuery({
      type: props.type,
      from: props.from,
      to: props.to,
    });
    if (query.value) {
      store.commit(STATS.SET_AVG_COMMUTE_MODE_DISTANCE_STATS_QUERY, query);
    }
    return { query };
  },
};
</script>
